import pluralize from "@/lib/pluralize";

export function formatPastPresidentsRosterCount(currentCount: number): string {
  return `${currentCount} ${pluralize(currentCount, "Past President")}`;
}
